import { atom } from "recoil";
export const usersList = atom({
    key: "usersList", // unique ID (with respect to other atoms/selectors)
    default: "", // default value (aka initial value)
});
